import React from 'react';

import MDBox from 'components/MDBox';
import DataTable from 'examples/Tables/DataTable';
import MDTypography from 'components/MDTypography';

import useUsersHook from '../../../hooks/useUsersHook';

const NonUSUsers = () => {
  const {
    columns,
    rows,
    totalCount,
    totalPage,
    isLoading,
    perPage,
    setPerPage,
    currentPage,
    setCurrentPage,
    setSortBy,
    sortBy,
  } = useUsersHook({
    usersFrom: 'non-us',
  });
  return (
    <>
      <MDBox
        mx={2}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Non US Users
        </MDTypography>
      </MDBox>

      <MDBox
        mt={3}
        sx={{
          position: 'relative',
          paddingTop: '85px',
          paddingBottom: {
            xs: '150px',
            sm: '95px',
          },
        }}
      >
        <DataTable
          table={{ columns, rows }}
          isSorted={true}
          entriesPerPage={{ defaultValue: perPage }}
          showTotalEntries
          canSearch={false}
          // searchTerm={searchTerm}
          // setSearchTerm={setSearchTerm}
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPage={totalPage}
          totalRecords={totalCount}
          hiddenColumns={['id']}
          queryPageSortBy={[sortBy]}
          setSortBy={setSortBy}
          isLoading={isLoading}
        />
      </MDBox>
    </>
  );
};

export default NonUSUsers;
